import React from "react";
import { PenLine, History, CircleCheck, CircleX, Clock3 } from "lucide-react";
import { formatExcavationDate, formatExcavationWorkflowDate } from "./excavationViewData";
import "./excavationPermitDetails.css";

const text = value => value === null || value === undefined || value === "" ? "—" : String(value);
const signatureType = value => value ? String(value).replace(/_/g, " ").replace(/\b\w/g, letter => letter.toUpperCase()) : "Signature";

export function ExcavationSignatures({ signatures = [] }) {
  if (!signatures.length) return null;
  return (
    <div className="excavation-view-details">
      <section className="exc-view-card">
        <header className="exc-view-heading">
          <div className="exc-view-title"><PenLine size={22} aria-hidden="true" /><div><h2>Signatures</h2><p>Recorded signers and signing details</p></div></div>
          <span className="exc-view-tag">{signatures.length} {signatures.length === 1 ? "signature" : "signatures"}</span>
        </header>
        <ul className="exc-view-signatures">
          {signatures.map((signature, index) => (
            <li className="exc-view-signer" key={signature.id || index}>
              <div className="exc-view-signer-role"><PenLine size={17} aria-hidden="true" /><span>{signatureType(signature.type)}</span></div>
              <dl className="exc-view-signer-person"><div><dt>Name</dt><dd>{text(signature.name)}</dd></div><div><dt>Designation</dt><dd>{text(signature.designation)}</dd></div></dl>
              <dl className="exc-view-signer-date"><dt>Signed on (IST)</dt><dd>{formatExcavationDate(signature.date_time)}</dd></dl>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}

export function ExcavationWorkflowActivity({ logs = [] }) {
  if (!logs.length) return null;
  return (
    <div className="excavation-view-details">
      <section className="exc-view-card">
        <header className="exc-view-heading">
          <div className="exc-view-title"><History size={22} aria-hidden="true" /><div><h2>Workflow Activity Log</h2><p>Permit actions, status changes, and comments</p></div></div>
          <span className="exc-view-tag">{logs.length} {logs.length === 1 ? "activity" : "activities"}</span>
        </header>
        <ol className="exc-view-activity-list">
          {logs.map((log, index) => {
            const action = String(log.action || "").toLowerCase();
            const state = ["approve", "approved"].includes(action) ? "approved" : ["reject", "rejected"].includes(action) ? "rejected" : "pending";
            const Icon = state === "approved" ? CircleCheck : state === "rejected" ? CircleX : Clock3;
            return (
              <li className={`exc-view-activity ${state}`} key={log.id || index}>
                <span className="exc-view-activity-marker"><Icon size={19} aria-hidden="true" /></span>
                <div className="exc-view-activity-header">
                  <div className="exc-view-activity-title"><span className={`exc-view-status ${state}`}>{text(log.action)}</span>{log.department_name && <span>{log.department_name}</span>}</div>
                  <span className="exc-view-activity-date">{formatExcavationWorkflowDate(log.created_at)} <span>(IST)</span></span>
                </div>
                <p className="exc-view-activity-person"><strong>{text(log.user_name)}</strong>{log.user_designation && <span> · {log.user_designation}</span>}</p>
                {(log.from_status || log.to_status) && <div className="exc-view-status-change"><span className="exc-view-activity-label">Status</span><span>{text(log.from_status)}</span><span aria-label="changed to">→</span><strong>{text(log.to_status)}</strong></div>}
                {log.comments && <div className="exc-view-activity-comment"><span className="exc-view-activity-label">Comment</span><p>{log.comments}</p></div>}
              </li>
            );
          })}
        </ol>
      </section>
    </div>
  );
}
